/**
 * SaveValueChip.jsx — green "Save $X" badge (iter256).
 *
 * Renders when a product has BOTH a retail price and a lower
 * marketplace price. Shows the raw dollar saving; adds a percentage
 * in the tooltip.
 *
 * Zero-render when either price is missing or MP >= retail — so
 * existing Retail-only catalogues (Plaza, Tackle, HustleShop with no
 * mp_price on products) are visually unchanged.
 *
 * Props:
 *   retail (Number)  — retail price in AUD
 *   mp     (Number)  — marketplace price in AUD
 *   testid (String)  — optional stable data-testid
 */
export default function SaveValueChip({ retail, mp, testid }) {
  const r = Number(retail);
  const m = Number(mp);
  if (!Number.isFinite(r) || !Number.isFinite(m)) return null;
  if (r <= 0 || m <= 0 || m >= r) return null;
  const saving = r - m;
  const pct    = Math.round((saving / r) * 100);
  return (
    <span
      data-testid={testid || "save-value-chip"}
      title={`Save ${pct}% vs retail`}
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-emerald-500/10 text-emerald-700 dark:bg-emerald-500/20 dark:text-emerald-300 text-[11px] font-black tracking-wide"
    >
      Save ${saving.toFixed(saving < 10 ? 2 : 0)}
    </span>
  );
}
